const birght = {
  menu_background_color: "#006cb3",
  menu_text_color: "#FFFFFF",
  menu_ctive_text_color: "#ffe500"
};

const dark = {
  menu_background_color: "#3a3f51",
  menu_text_color: "#b5b6bd",
  menu_ctive_text_color: null
};

export { birght, dark };
